<template>
  <div class="search-input-component">
    <div class="uk-search uk-search-default uk-width-1-1 position-relative">
      <span class="uk-search-icon-flip" uk-search-icon></span>
      <input 
        v-model="internalValue"
        class="uk-search-input" 
        type="search" 
        :placeholder="placeholder || $t('general.search')"
        @input="handleInput"
      />
      <button 
        v-if="internalValue && internalValue.length > 0" 
        @click="clearSearch"
        class="clear-search-btn"
        type="button"
      >
        <i class="uil-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    debounce: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      internalValue: this.value || '',
      searchTimeout: null
    };
  },
  methods: {
    handleInput() {
      // Debounce ile input event'i emit et
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        this.$emit('input', this.internalValue);
        this.$emit('search', this.internalValue);
      }, this.debounce);
    },
    clearSearch() {
      this.internalValue = '';
      this.$emit('input', '');
      this.$emit('search', '');
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    }
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
};
</script>

<style scoped>
.search-input-component {
  width: 100%;
}

.uk-search-input {
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 10px 40px 10px 15px;
  font-size: 14px;
  transition: all 0.3s ease;
  width: 100%;
}

.uk-search-input:focus {
  border-color: #1e87f0;
  box-shadow: 0 0 0 3px rgba(30, 135, 240, 0.1);
  outline: none;
}

.uk-search-icon-flip {
  right: 40px;
  color: #999;
  z-index: 1;
}

.uk-search-input::placeholder {
  color: #999;
  opacity: 1;
}

.clear-search-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 2;
}

.clear-search-btn:hover {
  color: #666;
  transform: translateY(-50%) scale(1.1);
}

.clear-search-btn i {
  font-size: 16px;
}
</style>

